<template lang="html">
  <div>
    <v-form v-model="formularioValido" ref="form">
      <v-container>

        <!-- Contatos do coordenador -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <div class="tituloSecao">
              <label>Contatos do coordenador (disponíveis apenas para os administradores)</label>
            </div>
          </v-flex>
        </v-layout>

        <!-- E-mail -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              label='E-mail*'
              v-model="projetoPesquisa.emailCoordenador"
              counter="100"
              :rules="[...obrigatorio,...max100caracteres,...email]"
            >           
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Telefone -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              label="Telefone*"
              v-model="projetoPesquisa.telefoneCoordenador"
              counter="50"
              :rules="[...obrigatorio,...max50caracteres]"
            >           
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Contatos do projeto de pesquisa -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <div class="tituloSecao">
              <label>Contatos do projeto de pesquisa (as informações de contato abaixo ficarão disponíveis para a consulta pública)</label>
            </div>
          </v-flex>
        </v-layout>

        <!-- Nome do contato -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              label="Nome do contato*"
              v-model="projetoPesquisa.nomeContato"
              counter="200"
              :rules="[...obrigatorio,...max200caracteres]"
            >           
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- E-mail -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              label='E-mail*'
              v-model="projetoPesquisa.emailContato"
              counter="100"
              :rules="[...obrigatorio,...max100caracteres,...email]"
            >           
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Telefone -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              label="Telefone*"
              v-model="projetoPesquisa.telefoneContato"
              counter="50"
              :rules="[...obrigatorio,...max50caracteres]"
            >           
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Site -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              label="Site"
              v-model="projetoPesquisa.site"
              counter="50"
              :rules="max50caracteres"
            >           
            </v-text-field>
          </v-flex>
        </v-layout>

        <!-- Mídias sociais -->
        <v-layout row>
          <v-flex xs12>
            <v-textarea 
              label="Mídias sociais"
              v-model="projetoPesquisa.midiasSociais" 
              rows="1" 
              auto-grow 
              counter="100" 
              :rules="max100caracteres"
            >
            </v-textarea>
          </v-flex>
        </v-layout>

        <br>

      </v-container>
    </v-form>

    <v-divider></v-divider>

    <v-card-actions>

      <!-- Botão "Cancelar" -->
      <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Salvar" -->
      <v-btn color="primary" :disabled="!formularioValido" @click="editarProjetoPesquisa()">Salvar</v-btn>

    </v-card-actions>

  </div>
</template>

<script>
  import projetos from '@/utils/projetos'
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      projetoPesquisa: {
        emailCoordenador: '',
        telefoneCoordenador: '',
        nomeContato: '',
        emailContato: '',
        telefoneContato: '',
        site: '',
        midiasSociais: ''
      },
      obrigatorio: [v => !!v || 'Este campo é obrigatório'],
      max20caracteres: [v => v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres'],
      max50caracteres: [v => v.length <= 50 || 'Este campo pode ter no máximo 50 caracteres'],
      max100caracteres: [v => v.length <= 100 || 'Este campo pode ter no máximo 100 caracteres'],
      max200caracteres: [v => v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres'],
      max400caracteres: [v => v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres'],
      max2000caracteres: [v => v.length <= 2000 || 'Este campo pode ter no máximo 2000 caracteres'],
      email: [v => /.+@.+\..+/.test(v) || 'Digite um e-mail válido']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Edita um projeto de pesquisa.
      editarProjetoPesquisa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' })
        projetos.putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaContatos', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' })
        })
      },

      // Redireciona para a página de visualização da aba "Contatos".
      cancelar: function () {
        this.$router.push({name: 'ProjetoPesquisaContatos', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
      }
    },
    mounted () {
      // Carrega o projeto de pesquisa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
      projetos.getProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.projetoPesquisa = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }

  .v-radio-group_label {
    margin-top: 0;
  }
</style>

<style scoped>

  .tituloSecao {
    font-size: 1.1em;
    font-weight: bold;
    margin-bottom: 1em;
  }

</style>


// WEBPACK FOOTER //
// editar-contatos.vue?5dd5e33f